import { Storage } from 'aws-amplify';
import axios from 'axios';
import DOMPurify from 'dompurify';
import draftToHtml from 'draftjs-to-html';
import moment from 'moment';
import { Fragment, useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { CommonLoading } from 'react-loadingg';
import { useHistory, useParams } from 'react-router-dom';
import DatePickerRange from '../DatePickerRange/DatePickerRange';
import ImageCoverUploader from '../ImageCoverUploader/ImageCoverUploader';
import ImageUploader from '../ImageUploader/ImageUploader';
import RichTextEditor from '../RichTextEditor/RichTextEditor';
import EmployeeVisibilityDropdown from '../VisibilityDropdown/EmployeeVisibilityDropdown';
import { EntityList } from '../VisibilityDropdown/EntityList';
import EntityVisibilityDropdown from '../VisibilityDropdown/EntityVisibilityDropdown';

const EditBulletin = (props) => {
    const [isLoading, setIsLoading] = useState(true);

    const [bulletins, setBulletins] = useState('');
    const [title, setTitle] = useState('');
    const [encodedHtmlContent, setEncodedHtmlContent] = useState('');
    const [htmlContent, setHtmlContent] = useState('');
    const [employee, setEmployee] = useState('');
    const [image, setImage] = useState('');
    const [imageName, setImageName] = useState('');
    const [imageCover, setImageCover] = useState('');
    const [imageCoverName, setImageCoverName] = useState('');
    const [displayImage, setDisplayImage] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [modifiedBy, setModifiedBy] = useState('');
    const [displayPostDate, setDisplayPostDate] = useState('');
    const [displayPostTime, setDisplayPostTime] = useState('');

    const [selectedEntity, setSelectedEntity] = useState([]);

    const { REACT_APP_API_BACKEND_URL } = process.env;

    const { id } = useParams();

    const options = EntityList;

    // Find the bulletin with matching id
    useEffect(() => {
        const getBulletinInfo = async () => {
            const bulletinFromServer = await fetchBulletinInfo();

            const item = await bulletinFromServer.find(
                (bulletin) => bulletin.bbID === id
            );
            setBulletins(item);

            setTitle(item.title);
            setEmployee(item.employee);
            setDisplayStartTime(item.startDate);
            setImage(item.image);
            setImageCover(item.imageCover);
            setEncodedHtmlContent(item.desc);

            // Set entity on page load
            if (item.entity.indexOf(',') > -1) {
                let array = item.entity.split(',');
                let newArray = array.map((item) => ({
                    value: item,
                    label: item,
                }));
                setSelectedEntity(newArray);
            } else {
                let array = [{ value: item.entity, label: item.entity }];
                setSelectedEntity(array);
            }

            // Verify permission to access and verify if it's user's own bulletin
            const authorBadgeID = await item.createdByID;

            if (props.loginList) {
                const loginListFromParent = props.loginList;

                const permit = loginListFromParent.some(
                    (item) =>
                        (item.permissionName.includes('Admin Role') &&
                            item.permissionType.includes('edit')) ||
                        (item.permissionName.includes('Bulletin Board') &&
                            item.permissionType.includes('edit'))
                );

                const showSelfEdit =
                    authorBadgeID === props.badgeID ||
                    loginListFromParent.some(
                        (item) =>
                            item.permissionName.includes('Admin Role') &&
                            item.permissionType.includes('edit')
                    );

                if (!permit || !showSelfEdit) {
                    window.stop();
                    alert('You have no permissions to access this page.');
                    window.location = '/';
                } else {
                    setIsLoading(false);
                }
            }
        };

        getBulletinInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, props.loginList, props.badgeID]);

    // Fetch Bulletin
    const fetchBulletinInfo = async () => {
        const res = await fetch(
            REACT_APP_API_BACKEND_URL + '/api/bulletinboard/getbulletin'
        );
        const data = await res.json();

        return data.BBoardList;
    };

    useEffect(() => {
        setModifiedBy(localStorage.getItem('badgeID'));

        const insertData = async () => {
            const initialStartDate = await bulletins.startDate;
            const initialEndDate = await bulletins.endDate;
            setStartDate(moment(initialStartDate).format('YYYY-MM-DD HH:mm'));
            setEndDate(moment(initialEndDate).format('YYYY-MM-DD HH:mm'));

            setDisplayPostDate(moment(initialStartDate).format('DD MMMM'));
            setDisplayPostTime(moment(initialStartDate).format('hh:mm A'));
        };

        insertData();
    }, [bulletins]);

    useEffect(() => {
        const decodeContent = () => {
            let decodedHtml = decodeURIComponent(encodedHtmlContent);
            setHtmlContent(decodedHtml);
        };

        decodeContent();
    }, [encodedHtmlContent]);

    useEffect(() => {
        fetchImage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [image]);

    async function fetchImage() {
        if (image) {
            const imageUrl = await Storage.get(image);
            setDisplayImage(imageUrl);
        }
    }

    useEffect(() => {
        const getImageName = () => {
            if (image) {
                let inputString = image;
                let outputString = inputString.split('-hrcas3-');
                let imgName = outputString[1];
                setImageName(imgName);
            }
        };

        const getImageCoverName = () => {
            if (imageCover) {
                let inputString = imageCover;
                let outputString = inputString.split('-hrcas3-');
                let imgCoverName = outputString[1];
                setImageCoverName(imgCoverName);
            }
        };

        getImageName();
        getImageCoverName();
    }, [image, imageCover]);

    const getContent = (htmlContentProp) => {
        setHtmlContent(draftToHtml(htmlContentProp));
    };

    const getEmployeeVisibility = (employeeVisibilityProp) => {
        let newEmployee = employeeVisibilityProp.toString();
        setEmployee(newEmployee);
    };

    const getImageUrl = (uuidFileName, signedUrl) => {
        setImage(uuidFileName);
        setDisplayImage(signedUrl);
    };

    const getImageCoverUrl = (uuidFileName) => {
        setImageCover(uuidFileName);
    };

    const getStartTime = (startTimeProp) => {
        setStartDate(moment(startTimeProp).format('YYYY-MM-DD HH:mm'));
        // Set the display start time at mobile preview section
        setDisplayStartTime(startTimeProp);
    };

    const setDisplayStartTime = (displayStartTime) => {
        setDisplayPostDate(moment(displayStartTime).format('DD MMMM'));
        setDisplayPostTime(moment(displayStartTime).format('hh:mm A'));
    };

    const getEndTime = (endTimeProp) => {
        setEndDate(moment(endTimeProp).format('YYYY-MM-DD HH:mm'));
    };

    const createMarkup = (html) => {
        return {
            __html: DOMPurify.sanitize(html, {
                ADD_TAGS: ['iframe'],
                ADD_ATTR: [
                    'allow',
                    'allowfullscreen',
                    'frameborder',
                    'scrolling',
                ],
            }),
        };
    };

    const history = useHistory();

    // Edit Bulletin
    const editBulletin = async (bulletin) => {
        const url =
            REACT_APP_API_BACKEND_URL + '/api/bulletinboard/editbulletin';
        const bulletinDetails = {
            title: bulletin.title,
            desc: bulletin.desc,
            image: bulletin.image,
            imageCover: bulletin.imageCover,
            employee: bulletin.employee,
            entity: bulletin.entity,
            startDate: bulletin.startDate,
            endDate: bulletin.endDate,
            modifiedBy: bulletin.modifiedBy,
            bbID: bulletin.id,
        };
        axios
            .post(url, bulletinDetails)
            .then(
                (response) => alert('Bulletin has been successfully modified!'),
                setTimeout(() => {
                    history.push('/bulletinboard');
                    window.location.reload();
                }, 1000)
            )
            .catch((err) => console.error(err));
    };
    
    function fixedEncodeURIComponent(str) {
        return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
            return '%' + c.charCodeAt(0).toString(16);
        });
    }

    const onSubmit = (e) => {
        e.preventDefault();

        if (!title) {
            alert('Please enter a title');
        } else if (!htmlContent) {
            alert('Please enter your description');
        } else if (!employee) {
            alert('Please select an employee type');
        } else if (selectedEntity.length === 0) {
            alert('Please select an entity type');
        } else if (!image) {
            alert('Please upload an image first');
        } else if (startDate === endDate) {
            alert(
                'End date and time cannot be the same with start date and time!'
            );
        } else if (startDate > endDate) {
            alert('Start date/time cannot be greater than start date/time!');
        } else {
            // const desc = encodeURIComponent(htmlContent.replace(/'/g, "''"));
            const desc = fixedEncodeURIComponent(htmlContent)
            const entity = selectedEntity.map((x) => x.value).toString();

            editBulletin({
                title,
                desc,
                employee,
                entity,
                image,
                imageCover,
                startDate,
                endDate,
                modifiedBy,
                id,
            });
        }
    };

    return (
        <Fragment>
            {isLoading ? (
                <CommonLoading />
            ) : (
                <div className='main-hero-container'>
                    <div
                        className={`${
                            props.isActive ? 'container is-active' : 'container'
                        }`}
                    >
                        <Row>
                            <h1>Edit Bulletin</h1>
                            <Col xs={12} md={8}>
                                <form className='add-form' onSubmit={onSubmit}>
                                    <div className='form-control bulletin'>
                                        <label>Title</label>
                                        <input
                                            type='text'
                                            placeholder='Insert your title here...'
                                            style={{ width: '100%' }}
                                            value={title}
                                            onChange={(e) =>
                                                setTitle(e.target.value)
                                            }
                                        />
                                    </div>
                                    <div className='form-control bulletin'>
                                        <label>Description</label>
                                        {encodedHtmlContent && (
                                            <RichTextEditor
                                                getContent={getContent}
                                                htmlContent={encodedHtmlContent}
                                            />
                                        )}
                                    </div>
                                    <div className='form-control bulletin'>
                                        <label>Visible To</label>
                                        <EmployeeVisibilityDropdown
                                            getEmployeeVisibility={
                                                getEmployeeVisibility
                                            }
                                            employee={employee}
                                        />
                                        <EntityVisibilityDropdown
                                            options={options}
                                            value={selectedEntity}
                                            onChange={setSelectedEntity}
                                        />
                                    </div>
                                    <div className='form-control bulletin'>
                                        <label>Upload Image</label>
                                        <ImageUploader
                                            getImageUrl={getImageUrl}
                                            imageName={imageName}
                                        />
                                    </div>
                                    <div className='form-control bulletin'>
                                        <label>
                                            Upload Cover Image (Width 10.65cm x
                                            Height 3.75cm)
                                        </label>
                                        <ImageCoverUploader
                                            getImageCoverUrl={getImageCoverUrl}
                                            imageCoverName={imageCoverName}
                                        />
                                    </div>
                                    <div className='form-control bulletin'>
                                        <label>
                                            Set Display Date &amp; Time
                                        </label>
                                        <DatePickerRange
                                            getStartTime={getStartTime}
                                            getEndTime={getEndTime}
                                            startTime={bulletins.startDate}
                                            endTime={bulletins.endDate}
                                        />
                                    </div>
                                    <Button
                                        as='input'
                                        type='submit'
                                        value='Submit'
                                    />
                                    <Button
                                        variant='outline-primary'
                                        onClick={() =>
                                            history.push('/bulletinboard')
                                        }
                                    >
                                        Cancel
                                    </Button>
                                </form>
                            </Col>
                            <Col xs={12} md={4}>
                                <div className='preview-title-container'>
                                    <h5
                                        className='text-center'
                                        style={{
                                            fontWeight: 'bold',
                                            marginBottom: '0px',
                                        }}
                                    >
                                        Mobile Apps Preview
                                    </h5>
                                </div>
                                <Card
                                    style={{
                                        borderRadius: '30px',
                                        padding: '15px',
                                    }}
                                >
                                    <div className='flex-container'>
                                        {displayPostDate && (
                                            <div className='display-date'>
                                                {displayPostDate}
                                            </div>
                                        )}
                                        {displayPostTime && (
                                            <span
                                                style={{
                                                    alignSelf: 'center',
                                                    marginLeft: '5px',
                                                }}
                                            >
                                                {displayPostTime}
                                            </span>
                                        )}
                                    </div>
                                    {displayImage ? (
                                        <Card.Img
                                            variant='top'
                                            src={displayImage}
                                        />
                                    ) : (
                                        <div>[Image will be inserted here]</div>
                                    )}
                                    <Card.Body>
                                        <Card.Title>
                                            <strong>
                                                {title
                                                    ? title
                                                    : '[Title will be here]'}
                                            </strong>
                                        </Card.Title>
                                        <Card.Text>
                                            {htmlContent ? (
                                                <div
                                                    dangerouslySetInnerHTML={createMarkup(
                                                        htmlContent
                                                    )}
                                                />
                                            ) : (
                                                '[Content will be here]'
                                            )}
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default EditBulletin;
